import { selectCostCompare,selectCostRate,selectCostList,selectMaintainNumber,selectCarMaintain,selectMaintain } from "../../api/config/modules/MaintenanceAnalysis";

const state = {
    selectCostCompare: {},
    selectCostRate: {},
    selectCostList: {},
    selectMaintainNumber: {},
    selectCarMaintain: {},
    selectMaintain: {}
};

const mutations = {
  SET_SELECTCOSTCOMPARE: (state, selectCostCompare) => {
    state.selectCostCompare = selectCostCompare;
  },
  SET_SELECTCOSTRATE: (state, selectCostRate) => {
    state.selectCostRate = selectCostRate;
  },
  SET_SELECTCOSTLIST: (state, selectCostList) => {
    state.selectCostList = selectCostList;
  },
  SET_SELECTMAINTAINNUMBER: (state, selectMaintainNumber) => {
    state.selectMaintainNumber = selectMaintainNumber;
  },
  SET_SELECTCARMAINTAIN: (state, selectCarMaintain) => {
    state.selectCarMaintain = selectCarMaintain;
  },
  SET_SELECTMAINTAIN: (state, selectMaintain) => {
    state.selectMaintain = selectMaintain;
  },
};

const actions = {
  GET_SELECTCOSTCOMPARE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCostCompare(data)
        .then((res) => {
          commit("SET_SELECTCOSTCOMPARE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCOSTRATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCostRate(data)
        .then((res) => {
          commit("SET_SELECTCOSTRATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCOSTLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectCostList(data)
        .then((res) => {
          commit("SET_SELECTCOSTLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTMAINTAINNUMBER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectMaintainNumber(data)
        .then((res) => {
          commit("SET_SELECTMAINTAINNUMBER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTCARMAINTAIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectCarMaintain(data)
        .then((res) => {
          commit("SET_SELECTCARMAINTAIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_SELECTMAINTAIN: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      selectMaintain(data)
        .then((res) => {
          commit("SET_SELECTMAINTAIN", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
